<template>
  <div class="manual-step">
    <picture>
      <source type="image/webp" :srcset="item.src" />
      <img class="manual-step__img" :src="item.srcFallback" :alt="item.title" />
    </picture>

    <h3 class="manual-step__title">{{ item.title }}</h3>
  </div>
</template>

<script>
export default {
  name: "ManualStep",
  props: {
    item: Object
  }
};
</script>

<style lang="scss">
.manual-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: colors(text-2);
  width: 160px;

  &__img {
    margin-bottom: 10px;
  }

  &__title {
    font-size: 20px;
    font-weight: fw(bold);
    text-align: center;
    text-transform: uppercase;
  }
}
</style>
